module.exports = __webpack_public_path__ + "img/114-09-flat.e1b78f1c.jpg";